import { useRouter } from 'expo-router';

import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import { ILoyaltyBadge } from './types';

export const useBadgeDetailActions = (badge?: ILoyaltyBadge) => {
  const router = useRouter();

  const footerButtonLabel =
    badge && !badge.earnedAt && badge.lockedCtaText ? badge.lockedCtaText : t('gotIt');

  const handleClose = () => {
    if (router.canGoBack()) {
      router.back();
      return;
    }

    router.dismissTo(routes.rewardsProfile);
  };

  const handleCtaPress = () => {
    if (badge && !badge.earnedAt && badge.lockedCtaLink) {
      router.dismissTo(badge.lockedCtaLink);
      return;
    }

    handleClose();
  };

  return { handleClose, handleCtaPress, footerButtonLabel };
};
